import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function Seoresults() {
  return (
    <section className="seo_results p-100" style={{ background: "#F9F9F9" }}>
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="">
            <h2>TekRevol’s Result-driven SEO Strategy</h2>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <p>
              SEO services provided by TekRevol are strategic to provide optimal
              outcomes that can be considered long-term. First, we identify your
              specific business objectives and your target market to make sure
              that all the actions are consistent with your aims. Using
              state-of-the-art SEO tools and trends, we develop effective and
              lasting SEO strategies that can improve your online presence. Our
              team ensures that we are well informed on the current trends and
              updates in the algorithm to ensure that we can meet the
              ever-changing online market. Such dedication guarantees that every
              aspect of the SEO campaign launched is truly directed toward
              success.
            </p>
            <h5>
              Steps in <span style={{ color: "F47a14" }}>TekRevol's</span> SEO
              Strategy
            </h5>
          </Col>
        </Row>
        <Row className="mt-3 mt-md-4">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="">
            <div className="seo-result-main">
              <div className="seo-result-item">
                <div className="seo-result-box">
                  <div className="seo-num">01</div>
                  <h5>Discover</h5>
                  <p>
                    The first step involves a comprehensive investigation of
                    your company, its operating field, and competitors. During
                    this discovery phase, we define key opportunities and risks
                    that may influence the setting of an optimal SEO strategy.
                  </p>
                </div>
              </div>
              <div className="seo-result-item">
                <div className="seo-result-box">
                  <div className="seo-num">02</div>
                  <h5>Analyze</h5>
                  <p>
                    The evaluation carried out by our team includes an analysis
                    of your website’s technical condition, textual content, and
                    backlinks. It also gives us an understanding of several
                    areas that require attention so that we can effectively
                    implement what would have the most positive influence.
                  </p>
                </div>
              </div>
              <div className="seo-result-item">
                <div className="seo-result-box">
                  <div className="seo-num">03</div>
                  <h5>Strategize</h5>
                  <p>
                    From the above research, we then design the SEO strategy
                    that will meet your business needs. This comprises keyword
                    targeting, content mapping, technical SEO, and off-page
                    strategies aimed at elevating the site’s SERP position.
                  </p>
                </div>
              </div>
              <div className="seo-result-item">
                <div className="seo-result-box">
                  <div className="seo-num">04</div>
                  <h5>Execute</h5>
                  <p>
                    We deploy the strategy with efficiency, enhancing the
                    architecture, copy, and functionality of your website. Our
                    execution phase consists of producing and sharing
                    high-quality content, building credible backlinks, and
                    making your site mobile-friendly and fast.
                  </p>
                </div>
              </div>
              <div className="seo-result-item">
                <div className="seo-result-box">
                  <div className="seo-num">05</div>
                  <h5>Measure</h5>
                  <p>
                    Through regular and comprehensive reports, we can track the
                    effectiveness of your SEO campaign in real time. Using the
                    metrics of organic traffic, keyword positions, and
                    conversion rates, we evaluate the efficiency of the approach
                    and reveal its shortcomings.
                  </p>
                </div>
              </div>
              <div className="seo-result-item">
                <div className="seo-result-box">
                  <div className="seo-num">06</div>
                  <h5>Report</h5>
                  <p>
                    Our reports are clear, and comprehensive, with emphasis on
                    the achievements of the SEO campaign embarked on. Such
                    reports may feature traffic trends, referenced rankings, and
                    even ROI to provide a clear picture of how we help advance
                    your business.
                  </p>
                </div>
              </div>
              <div className="seo-result-item">
                <div className="seo-result-box">
                  <div className="seo-num">07</div>
                  <h5>Improvise</h5>
                  <p>
                    It is worth mentioning that SEO work is a long-term effort
                    and adjusting our approaches based on performance indicators
                    and changes in trends is a priority. We always adapt to the
                    changes in approaches to make your site remain relevant on
                    the search engine results page and provide sustainable
                    benefits.
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Seoresults;
